import React, {useContext} from "react";
import {Box, Grid, Link, Typography} from "@mui/material";
import {ForgottenPasswordContext} from "./ForgotPasswordView";
import letterImage from "../../assets/img/letter.png";
import {useLxTranslations} from "@lxo-blocks/react";
import {FORGOT_PASSWORD_FORM_TRANSLATION} from "./ForgotPasswordForm.translation.de";

export default function SuccessForm(props: any) {
    const {t, LxTrans} = useLxTranslations(FORGOT_PASSWORD_FORM_TRANSLATION);

    const context = useContext(ForgottenPasswordContext);

    return (
        <>
            <Box>
                <Box>
                    <Grid container justifyContent={"center"}>
                        <img
                            src={letterImage}
                            alt={t(
                                "FORGOT_PASSWORD_LETTER_IMAGE_ALT_TEXT"
                            )}
                        />
                    </Grid>
                    <Box mt={8} textAlign={"center"}>
                        <Typography variant={"h2"}>
                            <LxTrans i18nKey="FORGOT_PASSWORD_SUCCESS_PAGE_TEXT1"
                            />
                        </Typography>
                    </Box>
                </Box>
                <Box mt={4} textAlign={"center"}>
                    <LxTrans
                        i18nKey="FORGOT_PASSWORD_SUCCESS_PAGE_TEXT2"
                        values={{"email": context.email}}
                    />
                </Box>
                <Box mt={3} textAlign={"center"}>
                    <LxTrans
                        i18nKey="FORGOT_PASSWORD_SUCCESS_PAGE_TEXT3"
                        // eslint-disable-next-line
                        components={{anchor: <Link/>}}
                    />
                </Box>
            </Box>
        </>
    );
}
